export default "__VITE_ASSET__Doj5aDxO__"